/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const CREATE_PARTICIPANT_ANSWERS_V2 = gql`
  mutation CreateParticipantAnswersV2(
    $input: CreateParticipantAnswersInput!
    $caseId: String!
    $app: ApplicationInput!
  ) {
    createParticipantAnswersV2(input: $input, caseId: $caseId, app: $app)
  }
`;
